/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  ZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeParams,
  ZipCodeLocalAreaModel,
  ZipCodeLocalAreaModelBody,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useZipCodeLocalAreaGetZipCodeLocalAreasHook = () => {
  const zipCodeLocalAreaGetZipCodeLocalAreas =
    useCustomInstance<ZipCodeLocalAreaModel[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return zipCodeLocalAreaGetZipCodeLocalAreas({
        url: `/api/ZipCodeLocalArea/GetZipCodeLocalAreas`,
        method: 'GET',
        signal,
      });
    },
    [zipCodeLocalAreaGetZipCodeLocalAreas]
  );
};

export const getZipCodeLocalAreaGetZipCodeLocalAreasQueryKey = () => {
  return [`/api/ZipCodeLocalArea/GetZipCodeLocalAreas`] as const;
};

export const useZipCodeLocalAreaGetZipCodeLocalAreasQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useZipCodeLocalAreaGetZipCodeLocalAreasHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useZipCodeLocalAreaGetZipCodeLocalAreasHook>>
    >,
    TError,
    TData
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getZipCodeLocalAreaGetZipCodeLocalAreasQueryKey();

  const zipCodeLocalAreaGetZipCodeLocalAreas =
    useZipCodeLocalAreaGetZipCodeLocalAreasHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useZipCodeLocalAreaGetZipCodeLocalAreasHook>>
    >
  > = ({ signal }) => zipCodeLocalAreaGetZipCodeLocalAreas(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useZipCodeLocalAreaGetZipCodeLocalAreasHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ZipCodeLocalAreaGetZipCodeLocalAreasQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useZipCodeLocalAreaGetZipCodeLocalAreasHook>>
  >
>;
export type ZipCodeLocalAreaGetZipCodeLocalAreasQueryError = unknown;

export const useZipCodeLocalAreaGetZipCodeLocalAreas = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useZipCodeLocalAreaGetZipCodeLocalAreasHook>>
  >,
  TError = unknown,
>(options?: {
  query?: UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useZipCodeLocalAreaGetZipCodeLocalAreasHook>>
    >,
    TError,
    TData
  >;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useZipCodeLocalAreaGetZipCodeLocalAreasQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeHook = () => {
  const zipCodeLocalAreaFindZipCodeLocalAreaByZipCode =
    useCustomInstance<ZipCodeLocalAreaModel>();

  return useCallback(
    (
      params?: ZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeParams,
      signal?: AbortSignal
    ) => {
      return zipCodeLocalAreaFindZipCodeLocalAreaByZipCode({
        url: `/api/ZipCodeLocalArea/FindZipCodeLocalAreaByZipCode`,
        method: 'GET',
        params,
        signal,
      });
    },
    [zipCodeLocalAreaFindZipCodeLocalAreaByZipCode]
  );
};

export const getZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeQueryKey = (
  params?: ZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeParams
) => {
  return [
    `/api/ZipCodeLocalArea/FindZipCodeLocalAreaByZipCode`,
    ...(params ? [params] : []),
  ] as const;
};

export const useZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeHook>
    >
  >,
  TError = unknown,
>(
  params?: ZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeHook
          >
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeQueryKey(params);

  const zipCodeLocalAreaFindZipCodeLocalAreaByZipCode =
    useZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeHook>
      >
    >
  > = ({ signal }) =>
    zipCodeLocalAreaFindZipCodeLocalAreaByZipCode(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeHook>
      >
    >
  >;
export type ZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeQueryError = unknown;

export const useZipCodeLocalAreaFindZipCodeLocalAreaByZipCode = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeHook>
    >
  >,
  TError = unknown,
>(
  params?: ZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useZipCodeLocalAreaFindZipCodeLocalAreaByZipCodeQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useZipCodeLocalAreaCreateZipCodeLocalAreaHook = () => {
  const zipCodeLocalAreaCreateZipCodeLocalArea = useCustomInstance<void>();

  return useCallback(
    (zipCodeLocalAreaModelBody: ZipCodeLocalAreaModelBody) => {
      return zipCodeLocalAreaCreateZipCodeLocalArea({
        url: `/api/ZipCodeLocalArea/CreateZipCodeLocalArea`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: zipCodeLocalAreaModelBody,
      });
    },
    [zipCodeLocalAreaCreateZipCodeLocalArea]
  );
};

export const useZipCodeLocalAreaCreateZipCodeLocalAreaMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useZipCodeLocalAreaCreateZipCodeLocalAreaHook>
      >
    >,
    TError,
    { data: ZipCodeLocalAreaModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useZipCodeLocalAreaCreateZipCodeLocalAreaHook>>
  >,
  TError,
  { data: ZipCodeLocalAreaModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const zipCodeLocalAreaCreateZipCodeLocalArea =
    useZipCodeLocalAreaCreateZipCodeLocalAreaHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useZipCodeLocalAreaCreateZipCodeLocalAreaHook>
      >
    >,
    { data: ZipCodeLocalAreaModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return zipCodeLocalAreaCreateZipCodeLocalArea(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ZipCodeLocalAreaCreateZipCodeLocalAreaMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useZipCodeLocalAreaCreateZipCodeLocalAreaHook>>
  >
>;
export type ZipCodeLocalAreaCreateZipCodeLocalAreaMutationBody =
  ZipCodeLocalAreaModelBody;
export type ZipCodeLocalAreaCreateZipCodeLocalAreaMutationError = unknown;

export const useZipCodeLocalAreaCreateZipCodeLocalArea = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useZipCodeLocalAreaCreateZipCodeLocalAreaHook>
      >
    >,
    TError,
    { data: ZipCodeLocalAreaModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useZipCodeLocalAreaCreateZipCodeLocalAreaHook>>
  >,
  TError,
  { data: ZipCodeLocalAreaModelBody },
  TContext
> => {
  const mutationOptions =
    useZipCodeLocalAreaCreateZipCodeLocalAreaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useZipCodeLocalAreaUpdateZipCodeLocalAreaHook = () => {
  const zipCodeLocalAreaUpdateZipCodeLocalArea = useCustomInstance<void>();

  return useCallback(
    (zipCodeLocalAreaModelBody: ZipCodeLocalAreaModelBody) => {
      return zipCodeLocalAreaUpdateZipCodeLocalArea({
        url: `/api/ZipCodeLocalArea/UpdateZipCodeLocalArea`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: zipCodeLocalAreaModelBody,
      });
    },
    [zipCodeLocalAreaUpdateZipCodeLocalArea]
  );
};

export const useZipCodeLocalAreaUpdateZipCodeLocalAreaMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useZipCodeLocalAreaUpdateZipCodeLocalAreaHook>
      >
    >,
    TError,
    { data: ZipCodeLocalAreaModelBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<
    ReturnType<ReturnType<typeof useZipCodeLocalAreaUpdateZipCodeLocalAreaHook>>
  >,
  TError,
  { data: ZipCodeLocalAreaModelBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const zipCodeLocalAreaUpdateZipCodeLocalArea =
    useZipCodeLocalAreaUpdateZipCodeLocalAreaHook();

  const mutationFn: MutationFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useZipCodeLocalAreaUpdateZipCodeLocalAreaHook>
      >
    >,
    { data: ZipCodeLocalAreaModelBody }
  > = (props) => {
    const { data } = props ?? {};

    return zipCodeLocalAreaUpdateZipCodeLocalArea(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ZipCodeLocalAreaUpdateZipCodeLocalAreaMutationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useZipCodeLocalAreaUpdateZipCodeLocalAreaHook>>
  >
>;
export type ZipCodeLocalAreaUpdateZipCodeLocalAreaMutationBody =
  ZipCodeLocalAreaModelBody;
export type ZipCodeLocalAreaUpdateZipCodeLocalAreaMutationError = unknown;

export const useZipCodeLocalAreaUpdateZipCodeLocalArea = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useZipCodeLocalAreaUpdateZipCodeLocalAreaHook>
      >
    >,
    TError,
    { data: ZipCodeLocalAreaModelBody },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<ReturnType<typeof useZipCodeLocalAreaUpdateZipCodeLocalAreaHook>>
  >,
  TError,
  { data: ZipCodeLocalAreaModelBody },
  TContext
> => {
  const mutationOptions =
    useZipCodeLocalAreaUpdateZipCodeLocalAreaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const useZipCodeLocalAreaSyncZipCodeLocalAreasWithEmployeesHook = () => {
  const zipCodeLocalAreaSyncZipCodeLocalAreasWithEmployees =
    useCustomInstance<void>();

  return useCallback(() => {
    return zipCodeLocalAreaSyncZipCodeLocalAreasWithEmployees({
      url: `/api/ZipCodeLocalArea/SyncZipCodeLocalAreasWithEmployees`,
      method: 'POST',
    });
  }, [zipCodeLocalAreaSyncZipCodeLocalAreasWithEmployees]);
};

export const useZipCodeLocalAreaSyncZipCodeLocalAreasWithEmployeesMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useZipCodeLocalAreaSyncZipCodeLocalAreasWithEmployeesHook
          >
        >
      >,
      TError,
      void,
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useZipCodeLocalAreaSyncZipCodeLocalAreasWithEmployeesHook
        >
      >
    >,
    TError,
    void,
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const zipCodeLocalAreaSyncZipCodeLocalAreasWithEmployees =
      useZipCodeLocalAreaSyncZipCodeLocalAreasWithEmployeesHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useZipCodeLocalAreaSyncZipCodeLocalAreasWithEmployeesHook
          >
        >
      >,
      void
    > = () => {
      return zipCodeLocalAreaSyncZipCodeLocalAreasWithEmployees();
    };

    return { mutationFn, ...mutationOptions };
  };

export type ZipCodeLocalAreaSyncZipCodeLocalAreasWithEmployeesMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useZipCodeLocalAreaSyncZipCodeLocalAreasWithEmployeesHook
        >
      >
    >
  >;

export type ZipCodeLocalAreaSyncZipCodeLocalAreasWithEmployeesMutationError =
  unknown;

export const useZipCodeLocalAreaSyncZipCodeLocalAreasWithEmployees = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useZipCodeLocalAreaSyncZipCodeLocalAreasWithEmployeesHook
        >
      >
    >,
    TError,
    void,
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<
        typeof useZipCodeLocalAreaSyncZipCodeLocalAreasWithEmployeesHook
      >
    >
  >,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    useZipCodeLocalAreaSyncZipCodeLocalAreasWithEmployeesMutationOptions(
      options
    );

  return useMutation(mutationOptions);
};
